import { render, staticRenderFns } from "./InquiryCategories.vue?vue&type=template&id=8a649184"
import script from "./InquiryCategories.vue?vue&type=script&lang=js"
export * from "./InquiryCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports